import axios from '@axios'

/**
 * ÍNDICE
 * 
 * {@link getAccounts} - Obtener cuentas
 * {@link getAccount} - Obtener cuenta
 * {@link addAccount} - Añadir cuenta 
 * {@link updateAccount} - Actualizar cuenta 
 * {@link deleteAccount} - Eliminar cuenta 
 */


    /**
     * Obtener todos los cuentas
     * @param {*} data Datos para filtrar la consulta
     * @returns   | error
     */
    export const getAccounts = function(queryParams)  {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/accounts', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }

    /**
     * 
     * @param {integer} id ID del cuenta 
     * @returns 
     */
    export const getAccount = function (id) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/accounts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
    }

    /**
     * 
     * @param {*} data Datos del cuenta 
     * @returns 
     */
    export const addAccount = function (data) {

        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/accounts`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }  
    }

    /**
     * 
     * @param {integer} id ID del cuenta a borrar 
     * @returns 
     */
    export const deleteAccount = function ( { id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/accounts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }

    /**
     * 
     * @param {*} data Datos del cuenta a actualizar 
     * @returns 
     */
    export const updateAccount = function (data, id) {
        try {

            return new Promise((resolve, reject) => {
                axios
                    .put(`/accounts/${data}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }
    
